<template>
  <section class="bento-section" id="san-pham">
    <div class="bento-container">
      <div class="bento-header">
        <h2 class="bento-title">{{ $t('home.products.title') || 'Danh mục tiêu biểu' }}</h2>
        <p class="bento-desc">
          {{ $t('home.products.subtitle') }}
        </p>
      </div>

      <div class="bento-grid" v-if="products.length > 0">
        <!-- Main Featured Product (Product 1) -->
        <div class="bento-card featured-card clickable" v-if="products[0]" @click="goToDetail(products[0])">
          <img :alt="getLangValue(products[0], 'name')" class="bento-img" :src="getImageUrl(products[0].avatar)" />

          <!-- QR Code Overlay -->
          <div class="card-qr-overlay" v-if="products[0].qrCode2 && products[0].qrCode2.fileId" @click.stop>
            <img :src="apiView + products[0].qrCode2.fileId" alt="QR Code" class="card-qr-image" />
          </div>

          <div class="bento-overlay">
            <span class="bento-tag">{{ getLangValue(products[0], 'tenKhoaHoc') ||
              $t('home.products.dong_thap_specialty') || 'Đặc sản Đồng Tháp' }}</span>
            <h3 class="bento-card-title">{{ getLangValue(products[0], 'name') }}</h3>
            <p class="bento-card-desc">
              {{ getLangValue(products[0], 'moTa') || getLangValue(products[0], 'dacTinhSinhHoc') }}
            </p>
          </div>
        </div>

        <!-- Side Product 1 (Product 2) -->
        <div class="bento-card side-card clickable" v-if="products[1]" @click="goToDetail(products[1])">
          <img :alt="getLangValue(products[1], 'name')" class="bento-img" :src="getImageUrl(products[1].avatar)" />

          <!-- QR Code Overlay -->
          <div class="card-qr-overlay" v-if="products[1].qrCode2 && products[1].qrCode2.fileId" @click.stop>
            <img :src="apiView + products[1].qrCode2.fileId" alt="QR Code" class="card-qr-image" />
          </div>

          <div class="bento-overlay">
            <span class="bento-tag font-semibold" style="font-size: 10px;">
              {{ getLangValue(products[1], 'tenKhoaHoc') || $t('home.products.specialty_fruit') || 'Trái cây đặc sản'
              }}</span>
            <h3 class="bento-card-title sm-title">{{ getLangValue(products[1], 'name') }}</h3>
          </div>
        </div>

        <!-- Side Product 2 (Product 3) -->
        <div class="bento-card side-card clickable" v-if="products[2]" @click="goToDetail(products[2])">
          <img :alt="getLangValue(products[2], 'name')" class="bento-img" :src="getImageUrl(products[2].avatar)" />

          <!-- QR Code Overlay -->
          <div class="card-qr-overlay" v-if="products[2].qrCode2 && products[2].qrCode2.fileId" @click.stop>
            <img :src="apiView + products[2].qrCode2.fileId" alt="QR Code" class="card-qr-image" />
          </div>

          <div class="bento-overlay">
            <span class="bento-tag font-semibold" style="font-size: 10px;">
              {{ getLangValue(products[2], 'tenKhoaHoc') || $t('home.products.specialty_fruit') || 'Trái cây đặc sản'
              }}</span>
            <h3 class="bento-card-title sm-title">{{ getLangValue(products[2], 'name') }}</h3>
          </div>
        </div>

        <!-- Side Product 3 (Horizontal) (Product 4) -->
        <div class="bento-card horizontal-card clickable" v-if="products[3]" @click="goToDetail(products[3])">
          <img :alt="getLangValue(products[3], 'name')" class="bento-img" :src="getImageUrl(products[3].avatar)" />

          <!-- QR Code Overlay -->
          <div class="card-qr-overlay" v-if="products[3].qrCode2 && products[3].qrCode2.fileId" @click.stop>
            <img :src="apiView + products[3].qrCode2.fileId" alt="QR Code" class="card-qr-image" />
          </div>

          <div class="bento-overlay">
            <span class="bento-tag">{{ getLangValue(products[3], 'tenKhoaHoc') || $t('home.products.ocop_dong_thap') ||
              'OCOP Đồng Tháp' }}</span>
            <h3 class="bento-card-title">{{ getLangValue(products[3], 'name') }}</h3>
            <p class="bento-card-desc">
              {{ getLangValue(products[3], 'moTa') || getLangValue(products[3], 'dienTichSanLuong') }}
            </p>
          </div>
        </div>
      </div>

      <!-- Nút xem tất cả sản phẩm phong cách Bento Button -->
      <div class="bento-footer-action">
        <router-link to="/trai-cay/danh-sach" class="btn-view-all">
          {{ $t('home.products.view_all') || 'Xem tất cả sản phẩm' }}
          <span class="isax isax-arrow-right-3 icon-arrow"></span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { traiCayModel } from "@/models/profession/traiCay/traiCayModel";

export default {
  name: "SanPhamTieuBieu",
  data() {
    return {
      products: [],
      apiView: process.env.VUE_APP_API_URL + 'filesminio/view/',
    };
  },
  mounted() {
    this.fetchProducts();
  },
  methods: {
    getLangValue(item, fieldName) {
      if (!item) return "";
      const currentLocale = this.$i18n ? this.$i18n.locale : "vi";
      if (currentLocale === "en") {
        const enField = `${fieldName}En`;
        return item[enField] || item[fieldName] || "";
      }
      return item[fieldName] || "";
    },
    async fetchProducts() {
      try {
        const params = {
          start: 1,
          limit: 4, // Khớp với cấu trúc bento grid 4 ô của giao diện
        };
        await this.$store
          .dispatch("profession/traiCay/traiCayStore/getPagingParams", params)
          .then((res) => {
            if (res && res.data && res.data.data) {
              this.products = res.data.data.map((item) => traiCayModel.fromJson(item));
            }
          });
      } catch (err) {
        console.error("Lỗi khi tải danh sách Danh mục tiêu biểu:", err);
      }
    },
    goToDetail(product) {
      console.info('Log on tap id: ', product.code);
      if (product) {
        this.$router.push({ path: `/trai-cay/chi-tiet/${product.code}` });
      }
    },
    getImageUrl(file) {
      if (!file) return "";
      if (file.fileId) {
        return `${process.env.VUE_APP_API_URL}filesminio/view/${file.fileId}`;
      }
      return file.path || "";
    },
  },
};
</script>

<style scoped>
/* ======================== BENTO GRID BAN ĐẦU ======================== */
.bento-section {
  padding: 80px 0;
  background-color: #f1f5eb;
}

.bento-container {
  max-width: var(--container-max, 1280px);
  margin: 0 auto;
  padding: 0 var(--spacing-gutter, 24px);
}

.bento-header {
  text-align: center;
  margin-bottom: 64px;
}

.bento-title {
  font-family: var(--font-heading, "Montserrat");
  font-size: var(--text-headline-md-size, 32px);
  font-weight: 600;
  color: var(--color-public-text-head, #1b5e20);
  margin-bottom: 16px;
}

.bento-desc {
  font-family: var(--font-body, "Inter");
  font-size: var(--text-body-md-size, 16px);
  color: var(--color-public-text-body, #40493d);
  max-width: 600px;
  margin: 0 auto;
}

.bento-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  height: auto;
}

@media (min-width: 768px) {
  .bento-grid {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
    height: 600px;
  }
}

.bento-card {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  background-color: #fff;
  border: 1px solid var(--surface-dim, #d7dbd2);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.bento-card:hover .bento-img {
  transform: scale(1.1);
}

.featured-card {
  grid-column: span 1;
  grid-row: span 1;
  height: 300px;
}

@media (min-width: 768px) {
  .featured-card {
    grid-column: span 2;
    grid-row: span 2;
    height: auto;
  }
}

.side-card {
  grid-column: span 1;
  grid-row: span 1;
  height: 250px;
}

@media (min-width: 768px) {
  .side-card {
    height: auto;
  }
}

.horizontal-card {
  grid-column: span 1;
  grid-row: span 1;
  height: 250px;
}

@media (min-width: 768px) {
  .horizontal-card {
    grid-column: span 2;
    grid-row: span 1;
    height: auto;
  }
}

.bento-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.bento-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 60%);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 24px;
}

.bento-tag {
  color: #ffdcc2;
  font-family: var(--font-body, "Inter");
  font-size: var(--text-label-sm-size, 12px);
  font-weight: 700;
  margin-bottom: 8px;
}

.bento-card-title {
  color: #fff;
  font-family: var(--font-heading, "Montserrat");
  font-size: var(--text-headline-sm-size, 24px);
  font-weight: 700;
  margin: 0 0 8px 0;
}

.bento-card-title.sm-title {
  font-size: 18px;
  margin: 0;
}

.bento-card-desc {
  color: rgba(255, 255, 255, 0.8);
  font-family: var(--font-body, "Inter");
  font-size: var(--text-body-sm-size, 14px);
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.clickable {
  cursor: pointer;
}

/* ======================== BENTO FOOTER ACTION ======================== */
.bento-footer-action {
  margin-top: 48px;
  text-align: center;
}

.btn-view-all {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  font-family: var(--font-heading, "Montserrat");
  font-weight: 700;
  font-size: 15px;
  padding: 14px 32px;
  border-radius: 9999px;
  text-decoration: none;
  box-shadow: 0 10px 15px -3px rgba(46, 125, 50, 0.25);
  transition: all 0.3s ease;
}

.btn-view-all:hover {
  transform: translateY(-2px);
  background-color: #1b5e20;
  box-shadow: 0 10px 20px -3px rgba(46, 125, 50, 0.35);
  color: #ffffff;
  text-decoration: none;
}

.icon-arrow {
  font-size: 18px;
  transition: transform 0.3s ease;
}

.btn-view-all:hover .icon-arrow {
  transform: translateX(4px);
}

/* QR code overlay nổi trên bento card */
.card-qr-overlay {
  position: absolute;
  top: 0.85rem;
  right: 0.85rem;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.95);
  padding: 0.28rem;
  border-radius: 0.57rem;
  box-shadow: 0 0.28rem 0.85rem rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-qr-overlay:hover {
  transform: scale(1.08);
  box-shadow: 0 0.43rem 1.14rem rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
}

.card-qr-image {
  width: 5.68rem;
  height: 5.68rem;
  object-fit: contain;
  display: block;
}
</style>
